module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "render-by"
  }, [_c('PrettySelect', {
    attrs: {
      "label": "View By",
      "options": _vm.renderableOptions,
      "value": _vm.currentMode
    },
    on: {
      "change": function (val) {
        _vm.currentMode = val
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8cb59cc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RenderByDropdown.vue
// module id = 757
// module chunks = 2